import {
    PENDING_BACKEND,
    STATIC_CHANNEL_COUNT,
    STATIC_COMMUNITY_COUNT,
} from '../../features/recentChat/fr59PendingBackend';
import { CHAT_FILTER, CHAT_TYPE_GROUP } from './Constant';

// Live map wins over the payload value — same precedence RecentChatItem draws the badge
// with. Diverging would show a chip count contradicting the badges beside it.
const unreadCountOf = (recent, unreadDataObj = {}) =>
    unreadDataObj?.[recent?.fromUserId]?.count ?? recent?.unreadCount ?? 0;

// A manual mark-as-unread counts as unread even though the counter is zero.
const isUnread = (recent, unreadDataObj) => unreadCountOf(recent, unreadDataObj) > 0 || recent?.unreadFlag === 1;

const isFavourite = recent => recent?.favouriteStatus === 1;

const isGroup = recent => recent?.chatType === CHAT_TYPE_GROUP;

// No conversation carries a community or channel type yet, so these match nothing and the
// chips render empty. See fr59PendingBackend for what has to land before they mean anything.
const isCommunity = recent => (PENDING_BACKEND.communities ? false : recent?.chatType === CHAT_FILTER.COMMUNITIES);

const isChannel = recent => (PENDING_BACKEND.channels ? false : recent?.chatType === CHAT_FILTER.CHANNELS);

export const matchesChatFilter = (item, filter, unreadDataObj) => {
    const recent = item?.recent;
    if (!recent) return false;

    switch (filter) {
        case CHAT_FILTER.UNREAD:
            return isUnread(recent, unreadDataObj);
        case CHAT_FILTER.FAVORITES:
            return isFavourite(recent);
        case CHAT_FILTER.GROUPS:
            return isGroup(recent);
        case CHAT_FILTER.COMMUNITIES:
            return isCommunity(recent);
        case CHAT_FILTER.CHANNELS:
            return isChannel(recent);
        default:
            return true;
    }
};

// One pass instead of six `filter` calls: this reruns on every message and keystroke.
export const countByChatFilter = (items = [], unreadDataObj) => {
    const counts = {
        [CHAT_FILTER.ALL]: 0,
        [CHAT_FILTER.UNREAD]: 0,
        [CHAT_FILTER.FAVORITES]: 0,
        [CHAT_FILTER.GROUPS]: 0,
        [CHAT_FILTER.COMMUNITIES]: STATIC_COMMUNITY_COUNT,
        [CHAT_FILTER.CHANNELS]: STATIC_CHANNEL_COUNT,
    };

    items.forEach(item => {
        const recent = item?.recent;
        if (!recent) return;
        counts[CHAT_FILTER.ALL] += 1;
        if (isUnread(recent, unreadDataObj)) counts[CHAT_FILTER.UNREAD] += 1;
        if (isFavourite(recent)) counts[CHAT_FILTER.FAVORITES] += 1;
        if (isGroup(recent)) counts[CHAT_FILTER.GROUPS] += 1;
        if (isCommunity(recent)) counts[CHAT_FILTER.COMMUNITIES] += 1;
        if (isChannel(recent)) counts[CHAT_FILTER.CHANNELS] += 1;
    });

    return counts;
};
